import { invoiceTaxTypes } from '@/utils/enums'

export default {
  customers: [],
  customerLastPOSRecord: [],
  products: [],
  products_list: [],
  sales: [],
  sale: {},
  salesItems: [],
  salesPayments: [],
  loading: false, // pos loader
  total: 0,
  product_grid_loading: false, // product grid loader
  product_grid_count: 0, // product grid loader
  FilteredCount: 0,
  'sale-list-dashboard': {
    count: 0,
    due_amount: 0,
    sales_amount: 0,
    sales_return_amount: 0
  },
  holdInvoices: [],
  invoice: null,
  productIds: [],

  // on browser calculation handle
  updateInvoiceId: 0,
  customerDetail: null,
  redeemType: null,
  redeemPoints: 0,
  remainingRedeemPoints: 0,
  invoice__products: [],
  invoiceTaxInfo: invoiceTaxTypes, // invoice tax information
  item__taxes: [] // category taxes
}
